<template>
  <ul class="chart-skills">
    <li :style="{ transform: `rotate(${values[0]}deg)` }">
      <span></span>
    </li>
    <li :style="{ transform: `rotate(${values[1]}deg)` }">
      <span></span>
    </li>
    <li :style="{ transform: `rotate(${values[2]}deg)` }">
      <span></span>
    </li>
    <li :style="{ transform: `rotate(${values[3]}deg)` }">
      <span></span>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["values"],
};
</script>

<style scoped>
.chart-skills {
  margin: 0 auto;
  padding: 0;
  list-style-type: none;
}

.chart-skills *,
.chart-skills::before {
  box-sizing: border-box;
}

.chart-skills {
  position: relative;
  width: 200px;
  height: 100px;
  overflow: hidden;
}

.chart-skills::before,
.chart-skills::after {
  position: absolute;
}

.chart-skills::before {
  content: "";
  width: inherit;
  height: inherit;
  border: 25px solid rgba(211, 211, 211, 0.3);
  border-bottom: none;
  border-top-left-radius: 175px;
  border-top-right-radius: 175px;
}

.chart-skills::after {
  content: "Total Pateints";
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #828282;
}

.chart-skills li {
  position: absolute;
  top: 100%;
  left: 0;
  width: inherit;
  height: inherit;
  border: 25px solid;
  border-top: none;
  border-bottom-left-radius: 175px;
  border-bottom-right-radius: 175px;
  transform-origin: 50% 0%;
}

.chart-skills li:nth-child(1) {
  z-index: 4;
  border-color: rgb(27, 200, 205);
}

.chart-skills li:nth-child(2) {
  z-index: 3;
  border-color: rgb(226, 136, 22);
}

.chart-skills li:nth-child(3) {
  z-index: 2;
  border-color: rgb(251, 96, 62);
}

.chart-skills li:nth-child(4) {
  z-index: 1;
  border-color: rgb(153, 95, 226);
}
</style>
